module.exports = __webpack_public_path__ + "img/feature-icon3.80fdb8d.svg";